export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const CLEAR_CURRENT_PROFILE = "CLEAR_CURRENT_PROFILE";
export const PROFILE_LOADING = "PROFILE_LOADING";
export const GET_PROFILE = "GET_PROFILE";
export const VERIF_PASS = "VERIF_PASS";
export const UPDATING_PASS = "UPDATING_PASS";
/* adding user steps — SAVE_USER / CLEAR_USER dropped in SCRUM-1024: both were
   single-reducer, so register_user now moves via the usersSlice actions.
   UPDATE_USER / POST_USER / DELETE_USER dropped in SCRUM-1033 for the same reason:
   the write thunks are createAppAsyncThunk now and write through their own
   `.fulfilled` cases, so nothing dispatches those strings. */

export const GET_ERRORS = "GET_ERRORS";
/* GET_USERS survives: it is still getUsers' success dispatch (the SCRUM-924
   contract) and the usersSlice write path for the list. */
export const GET_USERS = "GET_USERS";
export const UPDATE_STATUS = "UPDATE_STATUS";
